module.exports = __webpack_public_path__ + "img/9.dirty_lavatory_seat.a5e5f2b3.svg";